import { render } from "./TheConfirm.vue?vue&type=template&id=61822cb6"
import script from "./TheConfirm.vue?vue&type=script&lang=js"
export * from "./TheConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__